import { useDispatch } from 'ReusableFunctions/CustomHooks';
import ShortUniqueId from 'short-unique-id';
import { useSelector } from 'react-redux';
import { createSelector } from '@reduxjs/toolkit';

const readFile = (file) => {
    return new Promise((resolve, reject) => {
        let reader = new FileReader();
        reader.onloadend = () => {
            resolve({
                id: new ShortUniqueId({ length: 10 }),
                filename: file.name,
                filetype: file.type,
                fileimage: reader.result,
                datetime: file.lastModifiedDate.toLocaleString("en-IN"),
                filesize: filesizes(file.size),
            });
        };
        reader.onerror = reject;
        reader.readAsDataURL(file);
    });
};

function formatDateForInput(date) {
    if (!date) return ""; // Return empty if date is null
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
};

const filesizes = (bytes, decimals = 2) => {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
};

const JsonData = () => {
    //main selectors
    const dispatch = useDispatch();
    const selectCommonState = (state) => state.commonState;
    const selectAuthState = (state) => state.authState;

    const selectMemoizedStates = createSelector(
        [selectCommonState, selectAuthState],
        (commonState, authState) => ({ commonState, authState })
    );

    const { commonState, authState } = useSelector(selectMemoizedStates);

    const jsonOnly = {
        states: [
            { value: 1, label: 'Andaman and Nicobar Islands' },
            { value: 2, label: 'Andhra Pradesh' },
            { value: 3, label: 'Arunachal Pradesh' },
            { value: 4, label: 'Assam' },
            { value: 5, label: 'Bihar' },
            { value: 6, label: 'Chandigarh' },
            { value: 7, label: 'Chhattisgarh' },
            { value: 8, label: 'Dadra and Nagar Haveli' },
            { value: 9, label: 'Delhi' },
            { value: 10, label: 'Goa' },
            { value: 11, label: 'Gujarat' },
            { value: 12, label: 'Haryana' },
            { value: 13, label: 'Himachal Pradesh' },
            { value: 14, label: 'Jammu and Kashmir' },
            { value: 15, label: 'Jharkhand' },
            { value: 16, label: 'Karnataka' },
            { value: 17, label: 'Kerala' },
            { value: 18, label: 'Madhya Pradesh' },
            { value: 19, label: 'Maharashtra' },
            { value: 20, label: 'Manipur' },
            { value: 21, label: 'Meghalaya' },
            { value: 22, label: 'Mizoram' },
            { value: 23, label: 'Nagaland' },
            { value: 24, label: 'Odisha' },
            { value: 25, label: 'Puducherry' },
            { value: 26, label: 'Punjab' },
            { value: 27, label: 'Rajasthan' },
            { value: 28, label: 'Tamil Nadu' },
            { value: 29, label: 'Telangana' },
            { value: 30, label: 'Tripura' },
            { value: 31, label: 'Uttar Pradesh' },
            { value: 32, label: 'Uttarakhand' },
            { value: 33, label: 'West Bengal' }
        ],
        sectors: [
            {
                value: 1,
                label: "Academic",
                disabled: false
            },
            {
                value: 2,
                label: "Corporate",
                disabled: false
            },
            {
                value: 3,
                label: "Non-profit",
                disabled: false
            },
            {
                value: 4,
                label: "Startup",
                disabled: false
            },
            {
                value: 5,
                label: "Others",
                disabled: false
            },
        ],
        industry_sector: [
            {
                value: 1,
                label: "Agriculture",
                disabled: false
            },
            {
                value: 2,
                label: "Arts",
                disabled: false
            },
            {
                value: 3,
                label: "Construction",
                disabled: false
            },
            {
                value: 4,
                label: "Consumer Goods",
                disabled: false
            },
            {
                value: 5,
                label: "Corporate Services",
                disabled: false
            },
            {
                value: 6,
                label: "Design",
                disabled: false
            },
            {
                value: 7,
                label: "Education",
                disabled: false
            },
            {
                value: 8,
                label: "Energy and Mining",
                disabled: false
            },
            {
                value: 9,
                label: "Entertainment",
                disabled: false
            },
            {
                value: 10,
                label: "Finance",
                disabled: false
            },
            {
                value: 11,
                label: "Hardware and Networking",
                disabled: false
            },
            {
                value: 12,
                label: "Health Care",
                disabled: false
            },
            {
                value: 13,
                label: "Legal",
                disabled: false
            },
            {
                value: 14,
                label: "Manufacturing",
                disabled: false
            },
            {
                value: 15,
                label: "Media and Communications",
                disabled: false
            },
            {
                value: 16,
                label: "Nonprofit",
                disabled: false
            },
            {
                value: 17,
                label: "Public Administration",
                disabled: false
            },
            {
                value: 18,
                label: "Public Safety",
                disabled: false
            },
            {
                value: 19,
                label: "Real Estate",
                disabled: false
            },
            {
                value: 20,
                label: "Recreation and Travel",
                disabled: false
            },
            {
                value: 21,
                label: "Retail",
                disabled: false
            },
            {
                value: 22,
                label: "Software and IT Services",
                disabled: false
            },
            {
                value: 23,
                label: "Transportation and Logistics",
                disabled: false
            },
            {
                value: 24,
                label: "Wellness and Fitness",
                disabled: false
            },
            {
                value: 25,
                label: "Others",
                disabled: false
            },
            {
                value: 26,
                label: "Professional Services",
                disabled: false
            }
        ],
        gender: [
            {
                value: 1,
                label: "Male"
            },
            {
                value: 2,
                label: "Female"
            },
        ],
        register_job_type: [
            {
                value: 1,
                label: "Full-time"
            },
            {
                value: 2,
                label: "Part-time"
            },
            {
                value: 3,
                label: "Contract"
            },
            {
                value: 4,
                label: "Volunteer"
            }
        ],
        location_preference: [
            {
                value: 1,
                label: "Remote"
            },
            {
                value: 2,
                label: "Hybrid"
            },
            {
                value: 3,
                label: "In-person"
            },
        ],
        functional_specialization: [
            {
                value: 1,
                label: "Sales & Marketing",
                disabled: false
            },
            {
                value: 2,
                label: "Human Resources",
                disabled: false
            },
            {
                value: 3,
                label: "Technology & Technology Management",
                disabled: false
            },
            {
                value: 4,
                label: "Finance & Accounting",
                disabled: false
            },
            {
                value: 5,
                label: "C Suite and Board",
                disabled: false
            },
            {
                value: 6,
                label: "Others",
                disabled: false
            },
        ],
        mode_of_communication: [
            {
                value: 1,
                label: "Email",
                disabled: false
            },
            {
                value: 2,
                label: "Whatsapp",
                disabled: false
            },
            {
                value: 3,
                label: "Text message",
                disabled: false
            },
            {
                value: 4,
                label: "Phone",
                disabled: false
            },
            {
                value: 5,
                label: "Others",
                disabled: false
            },
        ]
    }

    const jsxJson = {
        //                                                              Professioanl manual registration form                                                                //


        //                                                              load                                                                  //
        // loadAddEditInputs: [
        //     {
        //         name: "Company Name",
        //         type: "text",
        //         category: "input",
        //         placeholder: "",
        //         value: state?.servicesState?.new_edit_load_card?.company_name || '',
        //         change: (e) => dispatch(handleLoadInputOnChange({ company_name: e.target.value })),
        //         isMandatory: true,
        //         Err: commonState?.validated && !state?.servicesState?.new_edit_load_card?.company_name ? "Company name required" : ''
        //     },
        //     {
        //         name: "Contact Number",
        //         type: "text",
        //         category: "input",
        //         placeholder: "",
        //         value: state?.servicesState?.new_edit_load_card?.contact_no || '',
        //         change: (e) => {
        //             if (/^\d*$/.test(e.target.value) && e.target.value.length <= 10) {
        //                 dispatch(handleLoadInputOnChange({ contact_no: e.target.value }))
        //             }
        //         },
        //         isMandatory: true,
        //         Err: commonState?.validated && !state?.servicesState?.new_edit_load_card?.contact_no ? "Contact number required" : ''
        //     },
        //     {
        //         name: "From",
        //         type: "text",
        //         category: "googleLocation",
        //         placeholder: "",
        //         value: state?.servicesState?.new_edit_load_card?.from_location || '',
        //         change: (e) => dispatch(handleLoadInputOnChange({ from_location: e.target.value })),
        //         placedSelectedClick: (slectedLoc) => dispatch(handleLoadInputOnChange({ from_location: slectedLoc })),
        //         isMandatory: true,
        //         Err: commonState?.validated && !state?.servicesState?.new_edit_load_card?.from_location ? "From location required" : ''
        //     },
        //     {
        //         name: "To",
        //         type: "text",
        //         category: "googleLocation",
        //         placeholder: "",
        //         value: state?.servicesState?.new_edit_load_card?.to_location || '',
        //         change: (e) => dispatch(handleLoadInputOnChange({ to_location: e.target.value })),
        //         placedSelectedClick: (slectedLoc) => dispatch(handleLoadInputOnChange({ to_location: slectedLoc })),
        //         isMandatory: true,
        //         Err: commonState?.validated && !state?.servicesState?.new_edit_load_card?.to_location ? "To location required" : ''
        //     },
        //     {
        //         name: "Material",
        //         type: "text",
        //         category: "input",
        //         placeholder: "",
        //         value: state?.servicesState?.new_edit_load_card?.material || '',
        //         change: (e) => dispatch(handleLoadInputOnChange({ material: e.target.value })),
        //         isMandatory: true,
        //         Err: commonState?.validated && !state?.servicesState?.new_edit_load_card?.material ? "Material required" : ''
        //     },
        //     {
        //         name: "Ton",
        //         type: "text",
        //         category: "input",
        //         placeholder: "",
        //         value: state?.servicesState?.new_edit_load_card?.tone || '',
        //         change: (e) => {
        //             if (/^\d*$/.test(e.target.value)) {
        //                 dispatch(handleLoadInputOnChange({ tone: e.target.value }))
        //             }
        //         },
        //         isMandatory: true,
        //         Err: commonState?.validated && !state?.servicesState?.new_edit_load_card?.tone ? "Tone required" : ''
        //     },
        //     {
        //         name: "Truck Body Type",
        //         type: "select",
        //         category: "select",
        //         placeholder: "",
        //         value: state?.servicesState?.new_edit_load_card?.truck_body_type || '',
        //         options: jsonOnly.truckBodyType,
        //         change: (e) => dispatch(handleLoadInputOnChange({ truck_body_type: e.target.value })),
        //         isMandatory: true,
        //         Err: commonState?.validated && !state?.servicesState?.new_edit_load_card?.truck_body_type ? "Truck body type required" : ''
        //     },
        //     {
        //         name: "No Of Tyres",
        //         type: "select",
        //         category: "select",
        //         placeholder: "",
        //         value: state?.servicesState?.new_edit_load_card?.no_of_tyres || '',
        //         options: jsonOnly.noOfTyres,
        //         change: (e) => dispatch(handleLoadInputOnChange({ no_of_tyres: e.target.value })),
        //         isMandatory: true,
        //         Err: commonState?.validated && !state?.servicesState?.new_edit_load_card?.no_of_tyres ? "No of tyres required" : ''
        //     },
        //     {
        //         name: "Description",
        //         type: "textbox",
        //         category: "textbox",
        //         placeholder: "",
        //         value: state?.servicesState?.new_edit_load_card?.description || '',
        //         change: (e) => dispatch(handleLoadInputOnChange({ description: e.target.value })),
        //         isMandatory: false,
        //         // Err: commonState?.validated && !state?.servicesState?.new_edit_load_card?.description ? "Description required" : ''
        //     }
        // ],

        //                                                              truck                                                                  //
        // truckAddEditInputs: [
        //     {
        //         name: "Vehicle Number",
        //         type: "select",
        //         category: "select",
        //         placeholder: "",
        //         value: state?.servicesState?.new_edit_truck_card?.vehicle_number || [],
        //         options: state?.servicesState?.user_vehicle_list,
        //         change: (value) => dispatch(handleTruckInputOnChange({ vehicle_number: value, vehicle_number_selected: value[0]?.label })),
        //         isMandatory: true,
        //         Err: commonState?.validated && !state?.servicesState?.new_edit_truck_card?.vehicle_number?.length ? "Vehicle number required" : ''
        //     },
        //     {
        //         name: "Company Name",
        //         type: "text",
        //         category: "input",
        //         placeholder: "",
        //         value: state?.servicesState?.new_edit_truck_card?.company_name || '',
        //         change: (e) => dispatch(handleTruckInputOnChange({ company_name: e.target.value })),
        //         isMandatory: true,
        //         Err: commonState?.validated && !state?.servicesState?.new_edit_truck_card?.company_name ? "Company name required" : ''
        //     },
        //     {
        //         name: "Contact Number",
        //         type: "text",
        //         category: "input",
        //         placeholder: "",
        //         value: state?.servicesState?.new_edit_truck_card?.contact_no || '',
        //         change: (e) => {
        //             if (/^\d*$/.test(e.target.value) && e.target.value.length <= 10) {
        //                 dispatch(handleTruckInputOnChange({ contact_no: e.target.value }))
        //             }
        //         },
        //         isMandatory: true,
        //         Err: commonState?.validated && !state?.servicesState?.new_edit_truck_card?.contact_no ? "Contact number required" : ''
        //     },
        //     {
        //         name: "Name of the transport",
        //         type: "text",
        //         category: "input",
        //         placeholder: "",
        //         value: state?.servicesState?.new_edit_truck_card?.name_of_the_transport || '',
        //         change: (e) => dispatch(handleTruckInputOnChange({ name_of_the_transport: e.target.value })),
        //         isMandatory: true,
        //         Err: commonState?.validated && !state?.servicesState?.new_edit_truck_card?.name_of_the_transport ? "Name of the transport required" : ''
        //     },
        //     {
        //         name: "Ton",
        //         type: "text",
        //         category: "input",
        //         placeholder: "",
        //         value: state?.servicesState?.new_edit_truck_card?.tone || '',
        //         change: (e) => {
        //             if (/^\d*$/.test(e.target.value)) {
        //                 dispatch(handleTruckInputOnChange({ tone: e.target.value }))
        //             }
        //         },
        //         isMandatory: true,
        //         Err: commonState?.validated && !state?.servicesState?.new_edit_truck_card?.tone ? "Ton required" : ''
        //     },
        //     {
        //         name: "Brand Name",
        //         type: "select",
        //         category: "select",
        //         placeholder: "",
        //         value: state?.servicesState?.new_edit_truck_card?.truck_brand_name || '',
        //         options: jsonOnly.truckBrand,
        //         change: (e) => dispatch(handleTruckInputOnChange({ truck_brand_name: e.target.value })),
        //         isMandatory: true,
        //         Err: commonState?.validated && !state?.servicesState?.new_edit_truck_card?.truck_brand_name ? "Truck brand name required" : ''
        //     },
        //     {
        //         name: "From",
        //         type: "text",
        //         category: "googleLocation",
        //         placeholder: "",
        //         value: state?.servicesState?.new_edit_truck_card?.from_location || '',
        //         change: (e) => dispatch(handleTruckInputOnChange({ from_location: e.target.value })),
        //         placedSelectedClick: (slectedLoc) => dispatch(handleTruckInputOnChange({ from_location: slectedLoc })),
        //         isMandatory: true,
        //         Err: commonState?.validated && !state?.servicesState?.new_edit_truck_card?.from_location ? "From location required" : ''
        //     },
        //     {
        //         name: "To",
        //         type: "text",
        //         category: "googleLocation",
        //         placeholder: "",
        //         value: state?.servicesState?.new_edit_truck_card?.to_location || [],
        //         change: (e) => dispatch(handleTruckInputOnChange({ to_location: e.target.value })),
        //         placedSelectedClick: (slectedLoc) => dispatch(handleTruckInputOnChange({ to_location: slectedLoc })),
        //         isMandatory: true,
        //         Err: commonState?.validated && !state?.servicesState?.new_edit_truck_card?.to_location ? "To location required" : ''
        //     },
        //     {
        //         name: "Truck Body Type",
        //         type: "select",
        //         category: "select",
        //         placeholder: "",
        //         value: state?.servicesState?.new_edit_truck_card?.truck_body_type || '',
        //         options: jsonOnly.truckBodyType,
        //         change: (e) => dispatch(handleTruckInputOnChange({ truck_body_type: e.target.value })),
        //         isMandatory: true,
        //         Err: commonState?.validated && !state?.servicesState?.new_edit_truck_card?.truck_body_type ? "Truck body type required" : ''
        //     },
        //     {
        //         name: "Truck Size",
        //         type: "text",
        //         category: "input",
        //         placeholder: "",
        //         value: state?.servicesState?.new_edit_truck_card?.truck_size || '',
        //         change: (e) => {
        //             if (/^\d*$/.test(e.target.value)) {
        //                 dispatch(handleTruckInputOnChange({ truck_size: e.target.value }))
        //             }
        //         },
        //         isMandatory: true,
        //         Err: commonState?.validated && !state?.servicesState?.new_edit_truck_card?.truck_size ? "Truck size required" : ''
        //     },
        //     {
        //         name: "No Of Tyres",
        //         type: "select",
        //         category: "select",
        //         placeholder: "",
        //         value: state?.servicesState?.new_edit_truck_card?.no_of_tyres || '',
        //         options: jsonOnly.noOfTyres,
        //         change: (e) => dispatch(handleTruckInputOnChange({ no_of_tyres: e.target.value })),
        //         isMandatory: true,
        //         Err: commonState?.validated && !state?.servicesState?.new_edit_truck_card?.no_of_tyres ? "No of tyres required" : ''
        //     },
        //     {
        //         name: "Description",
        //         type: "textbox",
        //         category: "textbox",
        //         placeholder: "",
        //         value: state?.servicesState?.new_edit_truck_card?.description || '',
        //         change: (e) => dispatch(handleTruckInputOnChange({ description: e.target.value })),
        //         isMandatory: false,
        //         // Err:commonState?.validated && !state?.servicesState?.new_edit_truck_card?.description ? "Description required" : ''
        //     }
        // ],

        //                                                               driver                                                                //
        // driverAddEditInputs: [
        //     {
        //         name: "Vehicle Number",
        //         type: "select",
        //         category: "select",
        //         placeholder: "",
        //         value: state?.servicesState?.new_edit_driver_card?.vehicle_number || [],
        //         options: state?.servicesState?.user_vehicle_list,
        //         change: (value) => dispatch(handleDriverInputOnChange({ vehicle_number: value, vehicle_number_selected: value[0]?.label })),
        //         isMandatory: true,
        //         Err: commonState?.validated && !state?.servicesState?.new_edit_driver_card?.vehicle_number?.length ? "Vehicle number required" : ''
        //     },
        //     {
        //         name: "Company Name",
        //         type: "text",
        //         category: "input",
        //         placeholder: "",
        //         value: state?.servicesState?.new_edit_driver_card?.company_name || '',
        //         change: (e) => dispatch(handleDriverInputOnChange({ company_name: e.target.value })),
        //         isMandatory: true
        //     },
        //     {
        //         name: "Driver Name",
        //         type: "text",
        //         category: "input",
        //         placeholder: "",
        //         value: state?.servicesState?.new_edit_driver_card?.driver_name || '',
        //         change: (e) => dispatch(handleDriverInputOnChange({ driver_name: e.target.value })),
        //         isMandatory: true
        //     },
        //     {
        //         name: "Contact Number",
        //         type: "text",
        //         category: "input",
        //         placeholder: "",
        //         value: state?.servicesState?.new_edit_driver_card?.contact_no || '',
        //         change: (e) => {
        //             if (/^\d*$/.test(e.target.value) && e.target.value.length <= 10) {
        //                 dispatch(handleDriverInputOnChange({ contact_no: e.target.value }))
        //             }
        //         },
        //         isMandatory: true
        //     },
        //     {
        //         name: "From",
        //         type: "text",
        //         category: "googleLocation",
        //         placeholder: "",
        //         value: state?.servicesState?.new_edit_driver_card?.from_location || '',
        //         change: (e) => dispatch(handleDriverInputOnChange({ from_location: e.target.value })),
        //         placedSelectedClick: (slectedLoc) => dispatch(handleDriverInputOnChange({ from_location: slectedLoc })),
        //         isMandatory: true
        //     },
        //     {
        //         name: "To",
        //         type: "text",
        //         category: "googleLocation",
        //         placeholder: "",
        //         value: state?.servicesState?.new_edit_driver_card?.to_location || '',
        //         change: (e) => dispatch(handleDriverInputOnChange({ to_location: e.target.value })),
        //         placedSelectedClick: (slectedLoc) => dispatch(handleDriverInputOnChange({ to_location: slectedLoc })),
        //         isMandatory: true
        //     },

        //     {
        //         name: "Truck Body Type",
        //         type: "select",
        //         category: "select",
        //         placeholder: "",
        //         value: state?.servicesState?.new_edit_driver_card?.truck_body_type || '',
        //         options: jsonOnly.truckBodyType,
        //         change: (e) => dispatch(handleDriverInputOnChange({ truck_body_type: e.target.value })),
        //         isMandatory: true
        //     },
        //     {
        //         name: "No Of Tyres",
        //         type: "select",
        //         category: "select",
        //         placeholder: "",
        //         value: state?.servicesState?.new_edit_driver_card?.no_of_tyres || '',
        //         options: jsonOnly.noOfTyres,
        //         change: (e) => dispatch(handleDriverInputOnChange({ no_of_tyres: e.target.value })),
        //         isMandatory: true
        //     },
        //     {
        //         name: "Description",
        //         type: "textbox",
        //         category: "textbox",
        //         placeholder: "",
        //         value: state?.servicesState?.new_edit_driver_card?.description || '',
        //         change: (e) => dispatch(handleDriverInputOnChange({ description: e.target.value })),
        //         isMandatory: false
        //     }
        // ],

        //                                                             buy and sell                                                            //
        // buyAndSellAddEdit: [
        //     {
        //         name: "Model Year",
        //         type: "select",
        //         category: "select",
        //         placeholder: "",
        //         options: modelYears(),
        //         value: state?.servicesState?.new_edit_buyAndsell_card?.model || '',
        //         change: (e) => dispatch(handleBuyAndSellInputOnChange({ model: e.target.value })),
        //         isMandatory: true,
        //         Err: commonState?.validated && !state?.servicesState?.new_edit_buyAndsell_card?.model ? "Model required" : ''
        //     },
        //     {
        //         name: "Brand Name",
        //         type: "select",
        //         category: "select",
        //         placeholder: "",
        //         value: state?.servicesState?.new_edit_buyAndsell_card?.brand || '',
        //         options: jsonOnly.truckBrand,
        //         change: (e) => dispatch(handleBuyAndSellInputOnChange({ brand: e.target.value })),
        //         isMandatory: true,
        //         Err: commonState?.validated && !state?.servicesState?.new_edit_buyAndsell_card?.brand ? "Brand required" : ''
        //     },
        //     {
        //         name: "Owner Name",
        //         type: "text",
        //         category: "input",
        //         placeholder: "",
        //         value: state?.servicesState?.new_edit_buyAndsell_card?.owner_name || '',
        //         change: (e) => dispatch(handleBuyAndSellInputOnChange({ owner_name: e.target.value })),
        //         isMandatory: true,
        //         Err: commonState?.validated && !state?.servicesState?.new_edit_buyAndsell_card?.owner_name ? "Owner name required" : ''
        //     },
        //     {
        //         name: "Vehicle Number",
        //         type: "select",
        //         category: "select",
        //         placeholder: "",
        //         value: state?.servicesState?.new_edit_buyAndsell_card?.vehicle_number || [],
        //         options: state?.servicesState?.user_vehicle_list,
        //         change: (value) => dispatch(handleBuyAndSellInputOnChange({ vehicle_number: value, vehicle_number_selected: value[0]?.label })),
        //         isMandatory: true,
        //         Err: commonState?.validated && !state?.servicesState?.new_edit_buyAndsell_card?.vehicle_number?.length ? "Vehicle number required" : ''
        //     },
        //     {
        //         name: "Kilometers driven",
        //         type: "text",
        //         category: "input",
        //         placeholder: "",
        //         value: state?.servicesState?.new_edit_buyAndsell_card?.kms_driven || '',
        //         change: (e) => {
        //             if (/^\d*$/.test(e.target.value)) {
        //                 dispatch(handleBuyAndSellInputOnChange({ kms_driven: e.target.value }))
        //             }
        //         },
        //         isMandatory: true,
        //         Err: commonState?.validated && !state?.servicesState?.new_edit_buyAndsell_card?.kms_driven ? "Kilometers required" : ''
        //     },
        //     {
        //         name: "Price",
        //         type: "text",
        //         category: "input",
        //         placeholder: "",
        //         value: state?.servicesState?.new_edit_buyAndsell_card?.price || '',
        //         change: (e) => {
        //             if (/^\d*$/.test(e.target.value)) {
        //                 dispatch(handleBuyAndSellInputOnChange({ price: e.target.value }))
        //             }
        //         },
        //         isMandatory: true,
        //         Err: commonState?.validated && !state?.servicesState?.new_edit_buyAndsell_card?.price ? "Price required" : ''
        //     },
        //     {
        //         name: "Tonnage",
        //         type: "text",
        //         category: "input",
        //         placeholder: "",
        //         value: state?.servicesState?.new_edit_buyAndsell_card?.tonnage || '',
        //         change: (e) => {
        //             if (/^\d*$/.test(e.target.value)) {
        //                 dispatch(handleBuyAndSellInputOnChange({ tonnage: e.target.value }))
        //             }
        //         },
        //         isMandatory: true,
        //         Err: commonState?.validated && !state?.servicesState?.new_edit_buyAndsell_card?.tonnage ? "Tonnage required" : ''
        //     },
        //     {
        //         name: "Location",
        //         type: "text",
        //         category: "googleLocation",
        //         placeholder: "",
        //         value: state?.servicesState?.new_edit_buyAndsell_card?.location || '',
        //         change: (e) => dispatch(handleBuyAndSellInputOnChange({ location: e.target.value })),
        //         placedSelectedClick: (slectedLoc) => dispatch(handleBuyAndSellInputOnChange({ location: slectedLoc })),
        //         isMandatory: true,
        //         Err: commonState?.validated && !state?.servicesState?.new_edit_buyAndsell_card?.location ? "Location required" : ''
        //     },
        //     {
        //         name: "Contact Number",
        //         type: "text",
        //         category: "input",
        //         placeholder: "",
        //         value: state?.servicesState?.new_edit_buyAndsell_card?.contact_no || '',
        //         change: (e) => {
        //             if (/^\d*$/.test(e.target.value) && e.target.value.length <= 10) {
        //                 dispatch(handleBuyAndSellInputOnChange({ contact_no: e.target.value }))
        //             }
        //         },
        //         isMandatory: true,
        //         Err: commonState?.validated && !state?.servicesState?.new_edit_buyAndsell_card?.contact_no ? "Contact Number required" : ''
        //     },

        //     {
        //         name: "Truck Body Type",
        //         type: "select",
        //         category: "select",
        //         placeholder: "",
        //         value: state?.servicesState?.new_edit_buyAndsell_card?.truck_body_type || '',
        //         options: jsonOnly.truckBodyType,
        //         change: (e) => dispatch(handleBuyAndSellInputOnChange({ truck_body_type: e.target.value })),
        //         isMandatory: true,
        //         Err: commonState?.validated && !state?.servicesState?.new_edit_buyAndsell_card?.truck_body_type ? "Truck Body Type required" : ''
        //     },
        //     {
        //         name: "No Of Tyres",
        //         type: "select",
        //         category: "select",
        //         placeholder: "",
        //         value: state?.servicesState?.new_edit_buyAndsell_card?.no_of_tyres || '',
        //         options: jsonOnly.noOfTyres,
        //         change: (e) => dispatch(handleBuyAndSellInputOnChange({ no_of_tyres: e.target.value })),
        //         isMandatory: true,
        //         Err: commonState?.validated && !state?.servicesState?.new_edit_buyAndsell_card?.no_of_tyres ? "No Of Tyres required" : ''
        //     },
        //     {
        //         name: "Upload image",
        //         type: "file",
        //         category: "input",
        //         placeholder: "",
        //         value: state?.servicesState?.new_edit_buyAndsell_card?.blog_image_show_ui || [],
        //         change: (e) => {
        //             // -- For Multiple File Input
        //             let myImages = state?.servicesState?.new_edit_buyAndsell_card?.blog_image_show_ui;
        //             let makeImagesList = [];

        //             // Use `Promise.all` to handle async file reading
        //             Promise.all(
        //                 Array.from(e.target.files).map((file) => readFile(file))
        //             )
        //                 .then((results) => {
        //                     makeImagesList = results;
        //                     if (myImages) {
        //                         makeImagesList = [...myImages, ...makeImagesList];
        //                     }

        //                     dispatch(handleBuyAndSellInputOnChange({ blog_image_show_ui: makeImagesList, blog_image_send_api: e.target.files }));
        //                 })
        //                 .catch((error) => console.error('Error reading files:', error));
        //         },
        //         isMandatory: true,
        //         Err: commonState?.validated && !state?.servicesState?.new_edit_buyAndsell_card?.blog_image_show_ui?.length ? "Image required" : ''
        //     },
        //     {
        //         name: "Description",
        //         type: "textbox",
        //         category: "textbox",
        //         placeholder: "",
        //         value: state?.servicesState?.new_edit_buyAndsell_card?.description || '',
        //         change: (e) => dispatch(handleBuyAndSellInputOnChange({ description: e.target.value })),
        //         isMandatory: false
        //     }
        // ],
    }

    return {
        "jsonOnly": jsonOnly,
        "jsxJson": jsxJson
    }
}

export default JsonData